import { Box, Paper } from '@mui/material'
import { calculateGeographicDistance } from '../../common/utils/geographic-utils'
import { useMeasurementUnits } from '~/common/use-measurement-units'

/**
 * CSS-based tooltip that follows the cursor showing distance from last point
 * Positioned using screen coordinates relative to map container
 * Points are in CRS.Simple pixel coordinates {x, y}
 */
export const DistanceTooltip = ({ lastPoint, cursorPosition, cursorScreenPos, climateBounds }) => {
  const { formatDistance } = useMeasurementUnits()

  if (!lastPoint || !cursorPosition || !cursorScreenPos) {
    return null
  }

  const distanceMeters = calculateGeographicDistance(lastPoint, cursorPosition, climateBounds, 2000)
  const displayText = formatDistance(distanceMeters)

  return (
    <Paper
      elevation={2}
      sx={{
        position: 'absolute',
        left: cursorScreenPos.x + 16,
        top: cursorScreenPos.y - 12,
        px: 1,
        py: 0.25,
        borderRadius: 1,
        pointerEvents: 'none',
        zIndex: 1001,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'primary.main',
      }}
    >
      <Box
        component="span"
        sx={{
          fontFamily: 'monospace',
          fontSize: '0.875rem',
          fontWeight: 600,
          color: 'primary.main',
        }}
      >
        {displayText}
      </Box>
    </Paper>
  )
}
